exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alert-card[_v-309103fe]{width:100%;margin-top:8px}.mdl-card__actions[_v-309103fe]{bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-309103fe&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/components/Alert.vue
// module id = 265
// module chunks = 0